<app-page-breadcrumb pageTitle="Invitaciones"></app-page-breadcrumb>

<!-- Drawer -->
<app-invitation-form-drawer></app-invitation-form-drawer>

<div class="space-y-4">
  <!-- ── Controls bar ─────────────────────────────────────────────────────── -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Gestiona las invitaciones enviadas a nuevos usuarios de tu organización.
    </p>
    <div class="flex items-center gap-1.5">
      <button
        type="button"
        (click)="showFilters = !showFilters"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
          ></path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <button
        (click)="openDrawer()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4v16m8-8H4"
          />
        </svg>
        Invitar usuario
      </button>
    </div>
  </div>

  <!-- ── Filters ───────────────────────────────────────────────────── -->
  @if (showFilters) {
    <div
      class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <!-- Búsqueda por correo -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Buscar por correo
          </label>
          <input
            type="text"
            [(ngModel)]="emailFilter"
            (ngModelChange)="searchInvitation()"
            placeholder="Correo invitado..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro Rol -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Rol
          </label>
          <select
            [(ngModel)]="roleFilter"
            (ngModelChange)="searchInvitation()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">
              {{ rolesLoading ? 'Cargando...' : 'Todos' }}
            </option>
            @for (role of roles; track role.id) {
              <option [ngValue]="role.id">{{ role.name }}</option>
            }
          </select>
        </div>

        <!-- Filtro Estado -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Estado
          </label>
          <select
            [(ngModel)]="statusFilter"
            (ngModelChange)="searchInvitation()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todos</option>
            <option [ngValue]="'ACCEPTED'">Aceptadas</option>
            <option [ngValue]="'PENDING'">Pendientes</option>
            <option [ngValue]="'EXPIRED'">Expiradas</option>
            <option [ngValue]="'REVOKED'">Revocadas</option>
          </select>
        </div>

        <!-- Filtro Creación Desde -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Creación desde
          </label>
          <input
            type="date"
            [(ngModel)]="fromDateFilter"
            (ngModelChange)="searchInvitation()"
            (click)="$any($event.target).showPicker?.()"
            (focus)="$any($event.target).showPicker?.()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro Creación Hasta -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Creación hasta
          </label>
          <input
            type="date"
            [(ngModel)]="toDateFilter"
            (ngModelChange)="searchInvitation()"
            (click)="$any($event.target).showPicker?.()"
            (focus)="$any($event.target).showPicker?.()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Botón Limpiar Filtros -->
        <div class="flex items-end">
          <button
            type="button"
            (click)="resetFilters()"
            class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ── Success banner ───────────────────────────────────────────────────── -->
  @if (successMessage) {
    <div
      class="p-3 bg-success-50 border border-success-200 rounded-lg dark:bg-success-500/10 dark:border-success-500/20 flex items-center gap-3"
    >
      <svg
        class="w-5 h-5 text-success-500 shrink-0"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <p class="text-sm text-success-700 dark:text-success-400">
        {{ successMessage }}
      </p>
    </div>
  }

  <!-- ── Error state ───────────────────────────────────────────────────────── -->
  @if (error) {
    <div
      class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
    >
      <div class="flex items-center gap-3">
        <svg
          class="w-5 h-5 text-error-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
  }

  <!-- ── Loading ───────────────────────────────────────────────────────────── -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
      ></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400"
        >Cargando invitaciones...</span
      >
    </div>
  }

  <!-- ── Table ─────────────────────────────────────────────────────────────── -->
  @if (!loading) {
    <div
      class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/3"
    >
      <div class="max-w-full overflow-x-auto custom-scrollbar">
        <table class="min-w-full">
          <thead class="border-b border-gray-100 dark:border-white/5">
            <tr>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Correo invitado
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Rol
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Estado
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Invitado por
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Expira
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Creada
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400"
              >
                Acciones
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-white/5">
            @if (invitations.length === 0) {
              <tr>
                <td
                  colspan="7"
                  class="px-5 py-12 text-center"
                >
                  <div
                    class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400"
                  >
                    <svg
                      class="w-12 h-12"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                    <span>No hay invitaciones registradas</span>
                    <button
                      type="button"
                      (click)="openDrawer()"
                      class="mt-1 text-sm text-brand-500 hover:underline"
                    >
                      Enviar la primera invitación
                    </button>
                  </div>
                </td>
              </tr>
            }

            @for (inv of invitations; track inv.id) {
              <tr>
                <td class="px-5 py-3 text-start text-theme-sm">
                  <span class="font-medium text-gray-800 dark:text-white/90">{{
                    inv.mailInvited
                  }}</span>
                </td>
                <td
                  class="px-5 py-3 text-start text-theme-sm text-gray-500 dark:text-gray-400"
                >
                  {{ inv.roleName }}
                </td>
                <td class="px-5 py-3 text-start text-theme-sm">
                  <span
                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium {{
                      statusColor(inv.status)
                    }}"
                  >
                    {{ statusLabel(inv.status) }}
                  </span>
                </td>
                <td
                  class="px-5 py-3 text-start text-theme-sm text-gray-500 dark:text-gray-400"
                >
                  {{ inv.invitedByFullname }}
                </td>
                <td class="px-5 py-3 text-start text-theme-sm">
                  @if (inv.status === 'PENDING') {
                    <span
                      [class]="
                        timeUntil(inv.expiresAt) === 'Expirada'
                          ? 'text-error-500 dark:text-error-400'
                          : 'text-gray-500 dark:text-gray-400'
                      "
                    >
                      {{ timeUntil(inv.expiresAt) }}
                    </span>
                  } @else {
                    <span class="text-gray-400 dark:text-gray-600">{{
                      formatDate(inv.expiresAt)
                    }}</span>
                  }
                </td>
                <td
                  class="px-5 py-3 text-start text-theme-sm text-gray-500 dark:text-gray-400"
                >
                  {{ formatDate(inv.createdAt) }}
                </td>
                <td class="px-5 py-3 text-center text-theme-sm">
                  <div
                    class="relative inline-block"
                    (click)="$event.stopPropagation()"
                  >
                    <button
                      type="button"
                      (click)="toggleMenu(inv, $event)"
                      class="rounded-lg p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-300 transition-colors disabled:opacity-50"
                      [disabled]="resendingId === inv.id"
                      title="Acciones"
                    >
                      @if (resendingId === inv.id) {
                        <span
                          class="inline-block w-4 h-4 border-2 border-brand-500 border-t-transparent rounded-full animate-spin"
                        ></span>
                      } @else {
                        <svg
                          class="w-4 h-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                          />
                        </svg>
                      }
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      @if (globalTotalPages >= 1) {
        <div
          class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4"
        >
          <div class="flex items-center justify-between gap-4 flex-wrap">
            <div class="flex items-center gap-2">
              <span class="text-sm text-gray-500 dark:text-gray-400"
                >{{ globalTotalElements }} registros</span
              >
              <select
                [ngModel]="pageSize"
                (ngModelChange)="changePageSize($event)"
                class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              >
                @for (opt of PAGE_SIZE_OPTIONS; track opt) {
                  <option [value]="opt">{{ opt }}</option>
                }
              </select>
            </div>
            <div class="flex items-center gap-2">
              <button
                type="button"
                (click)="cambiarPagina(globalPage - 1)"
                [disabled]="!hasPrevPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                Anterior
              </button>
              <div class="flex items-center gap-1.5">
                <span class="text-sm text-gray-500 dark:text-gray-400"
                  >Página</span
                >
                <select
                  [ngModel]="pageDisplay"
                  (ngModelChange)="cambiarPagina($event - 1)"
                  class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
                >
                  @for (p of pagesArray; track p) {
                    <option [value]="p">{{ p }}</option>
                  }
                </select>
                <span class="text-sm text-gray-500 dark:text-gray-400"
                  >de {{ globalTotalPages }}</span
                >
              </div>
              <button
                type="button"
                (click)="cambiarPagina(globalPage + 1)"
                [disabled]="!hasNextPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<!-- ── Menú de acciones (flotante, fuera del overflow de la tabla) ─────────────── -->
@if (menuInvitation; as inv) {
  <div
    class="fixed z-dropdown w-52 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg py-1"
    [style.top.px]="menuPosition.top"
    [style.left.px]="menuPosition.left"
    (click)="$event.stopPropagation()"
  >
    <!-- Ver detalle (todos los estados) -->
    <button
      type="button"
      (click)="openDetail(inv)"
      class="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
    >
      <svg
        class="w-4 h-4 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        />
      </svg>
      Ver detalle
    </button>

    <!-- Reenviar (PENDING / EXPIRED) -->
    @if (canResend(inv)) {
      <button
        type="button"
        (click)="resend(inv)"
        class="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
      >
        <svg
          class="w-4 h-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        Reenviar invitación
      </button>
    }

    <!-- Copiar enlace (PENDING / EXPIRED con enlace) -->
    @if (canCopyLink(inv)) {
      <button
        type="button"
        (click)="copyLink(inv)"
        class="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
      >
        <svg
          class="w-4 h-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13.828 10.172a4 4 0 010 5.656l-3 3a4 4 0 01-5.656-5.656l1.5-1.5m6.828-1.828a4 4 0 010-5.656l3-3a4 4 0 015.656 5.656l-1.5 1.5"
          />
        </svg>
        Copiar enlace
      </button>
    }

    <!-- Editar rol (PENDING / EXPIRED) -->
    @if (canEditRole(inv)) {
      <button
        type="button"
        (click)="openEditRole(inv)"
        class="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
      >
        <svg
          class="w-4 h-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          />
        </svg>
        Editar rol
      </button>
    }

    <!-- Revocar (solo PENDING) -->
    @if (canRevoke(inv)) {
      <div class="my-1 border-t border-gray-100 dark:border-gray-700"></div>
      <button
        type="button"
        (click)="revoke(inv)"
        class="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left text-error-600 dark:text-error-400 hover:bg-error-50 dark:hover:bg-error-500/10 transition-colors"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
          />
        </svg>
        Revocar invitación
      </button>
    }

    @if (canDeleteInvitation(inv)) {
      <div class="my-1 border-t border-gray-100 dark:border-gray-700"></div>
      <button
        type="button"
        (click)="deleteInvitation(inv)"
        class="w-full flex items-center gap-2.5 px-3 py-2 text-sm text-left text-error-600 dark:text-error-400 hover:bg-error-50 dark:hover:bg-error-500/10 transition-colors"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          ></path>
        </svg>
        Eliminar invitación
      </button>
    }
  </div>
}

<!-- ── Modal: Ver detalle ─────────────────────────────────────────────────────── -->
<app-modal
  [isOpen]="!!detailInvitation"
  (close)="closeDetail()"
  className="max-w-4xl mx-4 sm:mx-6"
>
  @if (detailInvitation; as inv) {
    <div class="p-6 sm:p-8">
      <!-- Header -->
      <div class="flex items-start justify-between gap-6 mb-4">
        <div class="flex items-center gap-2 mb-1">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            Detalle de la invitación
          </h3>
          <span
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium {{
              statusColor(inv.status)
            }}"
          >
            {{ statusLabel(inv.status) }}
          </span>
        </div>
      </div>

      <div
        class="space-y-6 pt-6 mb-6 border-t border-gray-200 dark:border-gray-700"
      >
        <div class="grid grid-cols-2 gap-3 text-sm">
          <div class="flex items-center gap-3">
            <div class="shrink-0 mt-0.5">
              <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                class="w-5 h-5 text-gray-400"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                ></path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Correo invitado
              </p>
              <p
                class="text-sm font-medium text-gray-900 dark:text-white break-all"
              >
                {{ inv.mailInvited }}
              </p>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div class="shrink-0 mt-0.5">
              <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                class="w-5 h-5 text-gray-400"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                ></path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Rol</p>
              <p
                class="text-sm font-medium text-gray-900 dark:text-white break-all"
              >
                {{ inv.roleName }}
              </p>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div class="shrink-0 mt-0.5">
              <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                class="w-5 h-5 text-gray-400"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                ></path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Empresa</p>
              <p
                class="text-sm font-medium text-gray-900 dark:text-white break-all"
              >
                {{ inv.businessName }}
              </p>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div class="shrink-0 mt-0.5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="w-5 h-5 text-gray-400"
              >
                <path
                  stroke="none"
                  d="M0 0h24v24H0z"
                  fill="none"
                />
                <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" />
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Invitado por
              </p>
              <p
                class="text-sm font-medium text-gray-900 dark:text-white break-all"
              >
                {{ inv.invitedByFullname }}
              </p>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div class="shrink-0 mt-0.5">
              <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                class="w-5 h-5 text-gray-400"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                ></path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Creada</p>
              <p
                class="text-sm font-medium text-gray-900 dark:text-white break-all"
              >
                {{ formatDate(inv.createdAt) }}
              </p>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div class="shrink-0 mt-0.5">
              <svg
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                class="w-5 h-5 text-gray-400"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                ></path>
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs text-gray-500 dark:text-gray-400">Expira</p>
              <p
                class="text-sm font-medium text-gray-900 dark:text-white break-all"
              >
                {{ formatDate(inv.expiresAt) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      @if (inv.invitationLink) {
        <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
          <dt
            class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1.5"
          >
            Enlace de invitación
          </dt>
          <div class="flex items-center gap-2">
            <input
              type="text"
              [value]="inv.invitationLink"
              readonly
              class="flex-1 h-10 rounded-lg border border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 px-3 text-xs text-gray-600 dark:text-gray-300"
            />
            <button
              type="button"
              (click)="copyLink(inv)"
              class="shrink-0 inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-600 px-3 h-10 text-xs font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            >
              Copiar
            </button>
          </div>
        </div>
      }

      <div class="mt-6 flex justify-end">
        <app-button
          variant="outline"
          (btnClick)="closeDetail()"
          >Cerrar</app-button
        >
      </div>
    </div>
  }
</app-modal>

<!-- ── Modal: Editar rol ──────────────────────────────────────────────────────── -->
<app-modal
  [isOpen]="!!editRoleInvitation"
  (close)="closeEditRole()"
  className="max-w-md mx-4"
>
  @if (editRoleInvitation; as inv) {
    <div class="p-6 sm:p-8">
      <div class="mb-5">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
          Editar rol
        </h2>
        <p class="mt-0.5 text-sm text-gray-500 dark:text-gray-400">
          Cambia el rol asignado a
          <span class="font-medium text-gray-700 dark:text-gray-300">{{
            inv.mailInvited
          }}</span
          >.
        </p>
      </div>

      <div>
        <label
          class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          Rol <span class="text-error-500">*</span>
        </label>
        <select
          [(ngModel)]="editRoleId"
          [disabled]="rolesLoading || editRoleSaving"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:focus:border-brand-800 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <option [ngValue]="null">
            {{ rolesLoading ? 'Cargando...' : '— Seleccionar rol —' }}
          </option>
          @for (role of roles; track role.id) {
            <option [ngValue]="role.id">{{ role.name }}</option>
          }
        </select>
      </div>

      <div class="mt-6 flex items-center justify-end gap-3">
        <app-button
          variant="outline"
          (btnClick)="closeEditRole()"
          >Cancelar</app-button
        >
        <app-button
          variant="primary"
          [disabled]="
            editRoleSaving || editRoleId === null || editRoleId === inv.roleId
          "
          (btnClick)="saveEditRole()"
        >
          {{ editRoleSaving ? 'Guardando...' : 'Guardar' }}
        </app-button>
      </div>
    </div>
  }
</app-modal>
